import type { DbClient } from "@tanstack/db";
import { apiPostForm } from "@softmax/observatory-client/client";
import type { UploadPostMediaResponse } from "@softmax/observatory-client/types";

export async function uploadPostImage({
  db,
  file,
  elevatedPrivileges,
}: {
  db: DbClient;
  file: File;
  elevatedPrivileges: boolean;
}) {
  const signal = db.requireDependency<AbortController>("lifetime").signal;
  const form = new FormData();
  form.append("file", file);
  const result = await apiPostForm<UploadPostMediaResponse>(
    "/v2/posts/media",
    form,
    { elevatedPrivileges, signal },
  ).catch((error: Error) => {
    db.requireDependency<(error: Error) => void>("reportAuthorizationError")(
      error,
    );
    throw error;
  });
  signal.throwIfAborted();
  return result.s3_key;
}
